<!-- 登录 -->
<template>
    <div class="detail-wrap">
        <Breadcrumb :title="title" />
        <el-row :gutter="18">
            <el-col :span="4">
                <el-row class="title"></el-row>
                <!-- <el-image :src="loginUrl" class="login-bg"></el-image> -->
            </el-col>
            <el-col :span="10">
                <el-row class="title">欢迎登录！</el-row>
                <el-tabs v-model="activeName" type="border-card"  style="width:600px;margin:30px">
                    <el-tab-pane label="密码登录" name="first">
                        <el-form :model="ruleForm1" :rules="rules" ref="ruleForm1" label-width="100px">
                            <el-form-item label="手机号" prop="username" required style="width:500px">
                                <el-input type="tel"  v-model="ruleForm1.username" 
                                placeholder="请输入手机号" maxlength="11"                                
                                @input="handleInput"></el-input>
                            </el-form-item>
                            <el-form-item label="密码" prop="password" required style="width:500px">
                                <el-input v-model="ruleForm1.password" :type="pwType" @input="pwInput" maxlength="16"
                                    autocomplete="new-password" placeholder="请输入密码"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" round :loading="false" style="width: 150px"
                                    @click="accountLogin('ruleForm1')">登录</el-button>
                                <el-button type="danger" round style="width: 150px;"
                                    @click="toRegister">注册</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="短信登录" name="second">
                        <el-form :model="ruleForm2" :rules="rules" ref="ruleForm2" label-width="100px">
                            <el-form-item label="手机号" prop="phone" required style="width:500px">
                                <el-input v-model="ruleForm2.phone" @input="handleInput2"
                                placeholder="请输入手机号" maxlength="11"></el-input>
                            </el-form-item>
                            <el-form-item label="验证码" prop="varifyCode" required style="width:500px">
                                <el-input v-model="ruleForm2.varifyCode" placeholder="请输入验证码">
                                    <template slot="append">
                                        <el-button @click="sendPhoneCode" :disabled="disabledCode">{{ codeMsg }}</el-button>
                                    </template>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" round style="width: 150px;" :loading="false"
                                    @click="loginSMS('ruleForm2')">登录</el-button>
                                <el-button type="danger" round style="width: 150px;"
                                    @click="toRegister">注册</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import loginUrl from '@/assets/images/login-bg-1.png'
import Breadcrumb from '@/components/Breadcrumb'
export default {
    components: {
        Breadcrumb
    },
    data() {
        return {
            ruleForm: {},
            activeName: 'first',
            ruleForm1: {
                username: '',
                password: '',
            },
            ruleForm2: {
                phone: '',
                varifyCode: '',
            },
            rules: {
                username: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { min: 1, max: 11, message: '长度在 1 到 11 个字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 1, max: 16, message: '长度在 1 到 16 个字符', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { min: 3, max: 11, message: '长度在 11 位字符', trigger: 'blur' }
                ],
                varifyCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    { min: 3, max: 6, message: '长度在 3 到 6 个字符', trigger: 'blur' }
                ],
            },
            codeMsg: '发送验证码',
            seconds: 120,
            timer: null,
            disabledCode: false,
            loginUrl,
            pwType: 'text',
            pwKey: 0,
        }
    },
    created() {
       
    },
    mounted() {

    },
    computed: {
        ...mapState(['isLogin']),
        title() {
            return this.$route.meta.title
        },
    },
    methods: {
        accountLogin(formName) {
            let { username, password } = this.ruleForm1;
            let type = this.$help.isMobile(username) ? 'PhonePassword' : 'UserCode';
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = {
                        opcode: this.$code.LoginCode,
                        login_type: type,
                        clientno: username,
                        password: password
                    }
                    this.$api.login(params).then(res => {
                        let data = res.data;
                        if (data.IsSuccess) {
                            localStorage.isLogin = 0;
                            localStorage.token = data.Tag;
                            localStorage.userId = username
                            // 直接调用accountInfo，移除setTimeout
                            this.accountInfo()
                        } else {
                            this.$message.error(data.Message)
                        }
                    }).catch(err => {
                        this.$message.error("登录失败，请重新登录")
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        loginSMS(formName) {
            let { phone, varifyCode } = this.ruleForm2;
            if (!this.$help.isMobile(phone)) {
                this.$message.error("请输入正确的手机号");
                return false;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = {
                        opcode: this.$code.LoginCode,
                        login_type: 'PhoneCode',
                        clientno: phone,
                        password: varifyCode
                    }
                    this.$api.login(params).then(res => {
                        let v = res.data;
                        if (v.IsSuccess) {
                            localStorage.isLogin = 0;
                            localStorage.token = v.Tag;
                            // 直接调用accountInfo，移除setTimeout
                            this.accountInfo()
                        } else {
                            this.$message.error(v.Message)
                        }
                    }).catch(err => {
                        this.$message.error("登录失败，请重新登录")
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        accountInfo() {
            let params = {
                opcode: this.$code.UserInfo
            }
            // 查询账户信息
            this.$api.requestAPI(params).then(res => {
                if (res.IsSuccess) {
                    let result = res.Data.DataTable[0]
                    localStorage.setItem('realName',result['姓名'])
                    localStorage.setItem('roles',result['角色'])
                    localStorage.setItem('playerNo',result['选手账号'])
                    if(result['角色'] === '裁判'){                        
                        let roleLevel = this.getRoleLevel(result['等级'])
                        localStorage.setItem('roleLevel',roleLevel)                        
                    }else{
                        localStorage.setItem('roleLevel',1)
                    }              
                    // 确保localStorage数据已保存
                    setTimeout(() => {
                        // 跳转到指定页面或首页
                        const redirectPath = this.$route.query.redirect || '/'
                        this.$router.push(redirectPath).catch(err => {
                            // 处理可能的跳转错误
                            console.error('跳转失败:', err)
                            // 尝试强制跳转
                            window.location.href = redirectPath
                        })

                        this.$message({
                            message: '登录成功',
                            type: 'success',
                            duration: 1000,
                        });
                    }, 100)
                }
            }).catch(err => {
                this.$message.error("登录失败，请重新登录")
            })
        },
        getRoleLevel(value){
            let n = 1;
            if(value.includes('初级')){
                n = 1
            }else if(value.includes('中级')){
                n = 2
            }else if(value.includes('高级')){
                n = 3
            }else if(value.includes('王牌')){
                n = 4
            }else if(value.includes('金牌')){
                n = 5
            }
            return n
        },
        sendPhoneCode() {
            if (this.ruleForm2.phone == '') {
                this.$message.error('请输入手机号');
                return false;
            }
            if (!this.$help.isMobile(this.ruleForm2.phone)) {
                this.$message.error('请输入正确的手机号');
                return false;
            }
            let params = {
                opcode: this.$code.SMS,
                v_phone: this.ruleForm2.phone,
            }

            this.$api._requestAPI(params).then(res => {
                if (res.IsSuccess) {
                    this.$message.success('发送成功')
                } else {
                    this.$message.error(res.Message)
                }
            }).catch(err => {
                console.log(err);
            })

            // 清除之前可能存在的定时器
            if (this.timer) {
                clearInterval(this.timer);
            }
            
            this.timer = setInterval(() => {
                if (this.seconds <= 0) {
                    clearInterval(this.timer);
                    this.disabledCode = false;
                    this.codeMsg = '重新发送';
                    this.seconds = 120;
                } else {
                    this.seconds--
                    this.disabledCode = true;
                    this.codeMsg = this.seconds + '秒后重发'
                }
            }, 1000)
        },
        pwInput(e) {
            if (e) {
                this.pwType = 'password'
            } else {
                this.pwKey++
                this.pwType = 'text'
            }
        },
        toRegister(){
            this.$router.push('/register')
        },
        // 只能输入数字，限制输入其它字符
        handleInput(value){
            const pattern = /^[0-9]\d*$/g
            if (pattern.test(value)) {
                // 双向绑定
                this.ruleForm1.username = value
            } else {
                // 输入值不为正整数，则从中提取出数字并拼接为字符串，赋值给username
                const num = value.match(/\d+/g)
                this.ruleForm1.username = num ? num.join('') : ''
            }
        },
        handleInput2(value){
            const pattern = /^[0-9]\d*$/g
            if (pattern.test(value)) {
                // 双向绑定
                this.ruleForm2.phone = value
            } else {
                // 输入值不为正整数，则从中提取出数字并拼接为字符串，赋值给phone
                const num = value.match(/\d+/g)
                this.ruleForm2.phone = num ? num.join('') : ''
            }
        }
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';

.detail-wrap {
    width: 1000px
}

.title {
    padding: 30px;
    font-size: 22px;
}
@media screen and (min-width: 769px){
  .detail-wrap{   
    width: 1000px; 
    .el-row{
    //   width: 50%
    }    
  }
  .dialog-login >>> .el-dialog{
        width: 30%
    }
}
@media screen and (max-width:768px){
  .detail-wrap{
    width: 80vw;
    margin-top: 0;
    padding: 30px;
    border: 0;
  }
  .dialog-login >>> .el-dialog{
    width: 45vh ;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/login/login.vue